import type { ReactNode } from 'react';

export const symbol_thermostat_arrow_down: ReactNode = (
	<svg xmlns="http://www.w3.org/2000/svg" viewBox="0 -960 960 960">
		<path
			fill="currentColor"
			d="M167-174q-53-53-53-129 0-48 24-90.5t66-68.5v-286q0-38 27-65t65-27q38 0 65 27t27 65v286q42 26 66 68.5t24 90.5q0 76-53 129t-129 53q-76 0-129-53Zm7-129h244q0-40-19-71.5T348-420l-20-9v-319q0-14-9-23t-23-9q-14 0-23 9t-9 23v319l-20 9q-32 14-51 46t-19 71Zm596 122-87-87q-9-9-9-21t9-21q9-9 21-9t21 9l36 36v-496q0-13 8.5-21t21.5-8q13 0 21.5 8.5T821-769v496l37-37q9-9 21-9t21 9q9 9 9 21t-9 21l-87 87q-9 9-21.5 9t-21.5-9Z"
		/>
	</svg>
);
